import * as Yup from "yup";
import _ from "lodash";

// Helper function to check for duplicate filenames
function hasDuplicates(array) {
  return array.length !== _.uniq(array).length;
}

const regex = {
  alphabetOnly: /^[a-zA-Z ]*$/,
  alphabetAndNumber: /^[a-zA-Z0-9 ]*$/,
  alphaNumeric: /^[a-zA-Z0-9]*$/,
  alphaNumericHyphenAndForwardSlash: /^[a-zA-Z0-9/-]*$/,
  numericOnly: /^[0-9]*$/,
  streetAddress: /^(?=.*[a-zA-Z]).*$/,
};

export const validationSchema = {
  //Loan Info
  loanAmount: Yup.number()
    .required("Required Funds (AUD) is mandatory")
    .typeError("Required Funds (AUD) is mandatory")
    .moreThan(14999, "Required Fund should be greater than or equal to AUD 15,000")
    .lessThan(2000001, "Required Fund should be less than or equal to AUD 2,000,000"),

  loanTenure: Yup.number()
    .required("Term (months) is mandatory")
    .typeError("Term (months) is mandatory"),
  // .moreThan("1", "Loan tenure should be a between 2 and 60.")
  // .lessThan("61", "Loan tenure should be a between 2 and 60."),

  loanPurpose: Yup.string()
    .trim()
    .required("Purpose is mandatory")
    .matches(regex.alphabetAndNumber, "Please enter valid purpose."),

  // Business Info
  businessRegNum: Yup.string()
    .trim()
    .required("ABN Number is mandatory")
    .min(11, "ABN Number must be 11 digit"),

  // .matches(regex.alphaNumericHyphenAndForwardSlash, "Please enter valid ABN number."),

  businessName: Yup.string()
    .trim()
    .required("Entity Name is mandatory")
    .matches(
      /^[a-zA-Z0-9\s&]+$/,
      "Please enter valid entity name. Only letters, numbers, spaces and & are allowed"
    )
    .min(2, "Minimum 2 characters are mandatory"),

  entityType: Yup.string().trim()
  .required("Entity Type is mandatory")
  .matches(regex.alphabetOnly, "Please enter valid entity type"),

  businessEmail: Yup.string()
    .email("Please enter valid email address.")
    .required("Email Address is mandatory"),

  // businessPhone: Yup.string()
  // .required("Mobile Number is mandatory")
  // .matches(/^\+61\s?\(\d{2,3}\)\s?\d{4}\s?\d{4}$/, "Please enter a valid mobile number"),

  businessPhone: Yup.string()
    .required("Mobile Number is mandatory")
    .matches(/^04\d{8}$/, "Please enter a valid 10-digit mobile number"),

  businessAddr: Yup.string()
    .trim()
    .required("Street Address is mandatory")
    .matches(regex.streetAddress,"Please enter valid street address")
    .max(500, "Street address must be less than 500 characters."),

  businessSuburb: Yup.string()
    .trim()
    .required("Suburb is mandatory")
    .matches(regex.alphabetOnly, "Please enter valid suburb."),

  businessState: Yup.string().trim()
  .required("State / Territory is mandatory")
  .matches(regex.alphabetOnly, "Please enter valid state / territory."),

  businessZipCode: Yup.string()
    .required("Area Code is mandatory")
    .matches(regex.numericOnly, "Please enter numbers only."),

  // Documents
  bankStatements: Yup.mixed().test("bankStatements", function (file) {
    // If no files, show mandatory message
    if (!file || !file.length) {
      return this.createError({
        message: "Bank Statements are mandatory",
      });
    }

    // Check for PDF format
    const allPDF = file.every(
      (f) => _.toLower(_.last(_.split(f?.name, "."))) === "pdf"
    );
    if (!allPDF) {
      return this.createError({
        message: "Only PDF files are allowed",
      });
    }

    // Check for duplicates
    const fileNames = file.map((f) => f.name);
    if (fileNames.length !== new Set(fileNames).size) {
      return this.createError({
        message: "File with this name already exists",
      });
    }

    return true;
  }),

  financeStatements: Yup.mixed().test("financeStatements", function (file) {
    // If no files, show mandatory message
    if (!file || !file.length) {
      return this.createError({
        message: "Financial Statements are mandatory",
      });
    }

    // Check for PDF format
    const allPDF = file.every(
      (f) => _.toLower(_.last(_.split(f?.name, "."))) === "pdf"
    );
    if (!allPDF) {
      return this.createError({
        message: "Only PDF files are allowed",
      });
    }

    // Check for duplicates
    const fileNames = file.map((f) => f.name);
    if (fileNames.length !== new Set(fileNames).size) {
      return this.createError({
        message: "File with this name already exists",
      });
    }

    return true;
  }),

  // Director Info
  directorName1: Yup.string()
    .trim()
    .required("Full Name is mandatory")
    .matches(regex.alphabetOnly, "Please enter valid full name."),

  driverLicenseNumber: Yup.string()
    .trim()
    .required("Driver's license number is mandatory"),

  directorEmail1: Yup.string()
    .email("Please enter valid email address.")
    .required("Email address is mandatory"),

  directorPhone1: Yup.string()
    .required("Mobile number is mandatory")
    .matches(/^04\d{8}$/, "Please enter a valid 10-digit mobile number"),

  directorAddress1: Yup.string()
    .required("Director address is mandatory")
    .matches(regex.streetAddress, "Please enter valid street address")
    .max(500, "Address must be less than 500 characters."),

  directorSuburb: Yup.string()
    .trim()
    .required("Suburb is mandatory")
    .matches(regex.alphabetOnly, "Please enter valid suburb."),

  directorState: Yup.string()
    .trim()
    .required("State / Territory is mandatory")
    .matches(regex.alphabetOnly, "Please enter valid state / territory."),

  directorZipCode1: Yup.string()
    .required("Area code is mandatory")
    .matches(regex.numericOnly, "Please enter numbers only."),

  // T&C
  checkTerms: Yup.bool().oneOf([true], "Message"),
  checkDataProtection: Yup.bool().oneOf([true], "Message"),
};
